// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"663b1dd7","136":"d48b5968","252":"fe6c9549","258":"bca50260","283":"5153356b","453":"16ad4935","484":"da125f83","499":"10168803","895":"72afdd5a"}[chunkId] + ".chunk.js";
};